module.exports = __webpack_public_path__ + "img/qr-app.3ff93fc.svg";